import { call, put, takeEvery } from 'redux-saga/effects';
import { sagaTypes } from './types';
import { getCurrencies, getCurrencyRate } from '../../api/currencies';
import { getCurrenciesAction, getCurrencyRateAction } from './action';
import { IAction } from '../utils';

export function* getCurrenciesWorkerSaga() {
  const res: string[] = yield call(getCurrencies);
  yield put(getCurrenciesAction(res || []));
}

export function* getCurrencyRateWorkerSaga({ payload }: IAction<string>) {
  const res: number = yield call(getCurrencyRate, payload as string);
  yield put(getCurrencyRateAction(res));
}

export function* currencyWatcherSaga() {
  yield takeEvery(sagaTypes?.GET_CURRENCIES, getCurrenciesWorkerSaga);
  yield takeEvery(sagaTypes?.GET_CURRENCY_RATE, getCurrencyRateWorkerSaga);
}
